var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bannerInfo)?_c('img',{staticClass:"single-banner-image",attrs:{"src":_vm._f("resizeThumbnail")(_vm.bannerInfo.thumbnail,{width: 750, height: 130}),"alt":""},on:{"click":function($event){$event.preventDefault();return _vm.clickEvent.apply(null, arguments)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }